import TimeStamp from "./timeStamp";

export class FormRules {
    constructor () {
        this.required = value => !!value || 'bitte eingeben';
        this.requiredPosNumber = value => parseInt(value) >= 0 || 'bitte eingeben';
        this.string = value => isNaN(value) || !value || 'bitte als Text eingeben (Telefonnummern z.B. mit Abstand nach Vorwahl)';
        this.requiredDate = value => !!value || 'bitte ein gültiges Datum eingeben!!';
        this.email = value => this.verifyEmail(value) || 'Bitte gültige E-Mail-Adresse eingeben!';
        this.url = value => this.verifyUrl(value) || 'Bitte gültigen URL (Link) eingeben!';
        this.zipCode = value => this.verifyZIPCode(value) || 'Bitte die Postleitzahl als Zahl eingeben!';
        this.password = {
            min: v => (v && v.length >= 6) || 'Mindestens 6 Zeichen',
        };
        this.passNr =  v => (v && v.length == 6) || 'Bitte genau 6 Zeichen eingeben!';
        this.agreed = value => !!value || 'Bitte bestätigen!';
        this.positiveInteger = value => (value > 0 && value%Math.trunc(value) === 0 ) ||
                                        'Bitte eine ganze Zahl größer 0 eingeben!';
        this.greaterEqualZero = value => (value >= 0 && value !== '' ) ||
                                        'Bitte eine Zahl größer oder gleich 0 eingeben!';
        this.notInFuture = value => value <= TimeStamp.getTodayString() || 'Datum darf nicht in Zukunft liegen'
    }

    verifyEmail(value) {
        if ( !value ) { return false}
        let parts = value.split("@");
        if ( parts.length === 1 ) { return false }
        let subparts = parts[1].split(".");
        return subparts.length > 1 && subparts[1].length>1 ;
    }

    verifyUrl(value) {
        if ( !value ) { return true}
        if ( value.indexOf('http://') === 0 ) { return true }
        //if ( value.indexOf('https://') === 0 ) { return true }
        return value.indexOf('https://') === 0;
    }

    verifyZIPCode(value) {
        return !isNaN(value) && !!value;
    }

}